import { CircularProgress } from '@mui/material'
import React,{useState,useEffect} from 'react'
import portalServices from '../portalServices';
import { useAlert } from '../../../context/AlertContext';
import moment from 'moment';
import ReopenComplaint from './ReopenComplaint';

function UserComplaintList({getMasterLabel,customerPhoneNo}) {


    const [complaintList,setComplaintList] = useState(null);

    const {AppAlert} = useAlert();
    const getComplaintList = () =>{
        setComplaintList(null);
        if(customerPhoneNo !== undefined && customerPhoneNo !== null && customerPhoneNo.length == 10 ) {
            portalServices.getComplaintList(customerPhoneNo).then(res=>{
                setComplaintList(res.data);
            }).catch(error=>{
                AppAlert("Somthing went Wrong while loading complaint Try again","error")
            }).finally(()=>{  
            })  
        } 
    }

    useEffect(()=>{
        getComplaintList();
    },[customerPhoneNo])


  return (
    <div className='row'>
    {!complaintList && 
        <div className='col-md-12 text-center'>
            <CircularProgress/>
        </div>
    }    

    {complaintList && complaintList.length === 0 &&
        <div className='col-md-12 text-center'>
            <h3>No Complaint Found</h3>
        </div>
    }

    { 
    complaintList && complaintList.map(complaint=>
        <div className='col-md-4 col-sm-12' key={complaint.id}>
            <div className='card mb-2'>
                <img src={complaint.photo} class="card-img-top" alt="complaint image" />
                <div className='card-body'>
                    <div><span className='fw-bold'>Complaint ID : </span>{complaint.id}</div>
                    <div><span className="fw-bold">Complaint About : </span> {getMasterLabel("grievance-type",complaint.grievanceType)}</div>
                    <div><p>{complaint.details}</p></div>
                    
                    <div> 
                        <span className="fw-bold">Current Status</span> {getMasterLabel("grievance-status",complaint.grievanceStatus)}
                    </div>
                    <div>{complaint.address}</div>
                    <div className='border p-2 rounded my-2'><span className="fw-bold"> Date : </span>{ moment(complaint.created_at).format("lll")} </div>
                    <a target='_blank' href={"https://www.google.com/maps/dir//"+complaint.latitude+", "+complaint.longitude} >Show Direction on Map</a>

                    <ReopenComplaint complaint={complaint} calback={getComplaintList} />
                    
                </div>
                
                { complaint.grievanceStatus === 1 &&
                    <div className={ 'border border-danger border-2 mb-0'}>
                    </div>
                }
                
                { complaint.grievanceStatus === 2 &&
                    <div className={ 'border border-warning border-2 mb-0'}>
                    </div>
                }
                { complaint.grievanceStatus === 3 &&
                    <div className={ 'border border-success border-2 mb-0'}>
                    </div>
                }

                { complaint.grievanceStatus === 4 &&
                    <div className={ 'border border-danger border-2 mb-0'}>
                    </div>
                }



            </div>
        </div>
    ) }
</div>
  )
}

export default UserComplaintList